import { translate } from '@gig/magic-common';
import { ValidationDisplay, required, minLength, maxLength, notOnlyWhitespaces } from '@gig/magic-form-builder';

function city() {
    return {
        id: 'city',
        serverId: 'addrLocality',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-city',
        properties: {
            placeholder: translate('sign-up-step-two.city.placeholder'),
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: required,
                message: translate('sign-up-step-two.city.required-error'),
            },
            {
                name: 'min-length',
                fn: minLength(2),
                message: translate('sign-up-step-two.city.min-length-error'),
            },
            {
                name: 'max-length',
                fn: maxLength(50),
                message: translate('sign-up-step-two.city.max-length-error'),
            },
            {
                name: 'not-only-whitespaces',
                fn: notOnlyWhitespaces,
                message: translate('sign-up-step-two.city.not-only-whitespaces-error'),
            },
        ],
    };
}

export { city };
